/* processor/actions */
import { action } from "typesafe-actions";
import { Processor, ProcessorActionTypes, Data } from "./types";

export const fetchRequest = (
  id: string | null,
  params?: {},
  callback?: () => unknown | null
) => action(ProcessorActionTypes.FETCH, { id, params, callback });

export const fetchSuccess = (data: Processor) =>
  action(ProcessorActionTypes.FETCH_SUCCESS, data);

export const fetchError = (error: string) =>
  action(ProcessorActionTypes.FETCH_ERROR, error);

export const saveRequest = (
  data: Data,
  callback?: (err: string | null, data: Processor | null) => unknown
) => action(ProcessorActionTypes.SAVE_REQUEST, { data, callback });

export const saveSuccess = (data: Processor) =>
  action(ProcessorActionTypes.SAVE_SUCCESS, data);

export const saveError = (error: string) =>
  action(ProcessorActionTypes.SAVE_ERROR, error);

export const deleteRequest = (
  id: string,
  callback?: (error: string | null) => unknown
) => action(ProcessorActionTypes.DELETE_REQUEST, { id, callback });

export const deleteSuccess = () => action(ProcessorActionTypes.DELETE_SUCCESS);

export const deleteError = (error: string) =>
  action(ProcessorActionTypes.DELETE_ERROR, error);
